import axios from "axios";
import { BASE_URL, HEADERS } from "../Utils/UrlUtils";


export const signin = (data) => {
    return axios.post(BASE_URL + '/auth/auth_signin', data);
}

export const getUser = () => {
    return JSON.parse(sessionStorage.getItem('candidateCreds'));
}

export const signout = () => {
    sessionStorage.removeItem('candidateCreds');
}

export const deleteUser = (email) => {
    return axios.get(BASE_URL + '/admin/admin_deleteUser/' + email);
}

export const signoutFromServer = () => {
    const URI = '/auth/auth_signout';
    return axios.post(BASE_URL + URI, {}, HEADERS());
}

export const candidate_auth_signout = () => {
    const URI = '/auth/candidate_auth_signout';
    return axios.post(BASE_URL + URI, {}, HEADERS());
}

export const validateToken = (token) => {
    const URI = `/auth/isValidCandidateToken/${token}`;
    return axios.get(BASE_URL + URI,HEADERS());
}

export const candidateHelpMessage = (data) => {
    return axios.post(BASE_URL + '/candidate-help/send', data);
}